import { useBreakpoint } from '~/hooks'
import { CrossSwapOrderStatus as OrderStatus } from '@tokenlon/v6-sdk'
import { getIsFailed, getIsSuccess } from './help'
import styled from 'styled-components'
import imgStatusBarSuccess from '~/assets/images/cross-swap-status-bar-success.svg'
import imgStatusBarFailed from '~/assets/images/cross-swap-status-bar-failed.svg'
import animationSuccessWeb from './json/cross-swap-status-bar-processing-web.json'
import animationSuccessMobile from './json/cross-swap-status-bar-processing-mobile.json'
import Lottie from '~/components/Lottie'
interface Props {
  status: OrderStatus
}

const StatusBar: React.FC<Props> = ({ status }) => {
  const { isMobile } = useBreakpoint()

  const renderContent = () => {
    const isFailed = getIsFailed(status)
    const isSuccess = getIsSuccess(status)

    if (isSuccess) {
      return <img src={imgStatusBarSuccess} />
    } else if (isFailed) {
      return <img src={imgStatusBarFailed} />
    } else {
      const animationData = isMobile
        ? animationSuccessMobile
        : animationSuccessWeb

      return (
        <Lottie
          animationData={animationData}
          autoPlay
          loop
          style={{ display: 'flex', flex: 1 }}
        />
      )
    }
  }

  return <StyledContainer>{renderContent()}</StyledContainer>
}

export default StatusBar

const StyledContainer = styled.div`
  img {
    width: 100%;
  }
`
